'use strict';

var window = require('window'),
    globalVars = window.globalVars || {},
    gtxConstants = window.gtxConstants || {};

module.exports = function (name) {
    var constant;

    if (typeof globalVars[name] !== 'undefined') {
        constant = globalVars[name];
    } else {
        constant = gtxConstants[name];
    }

    if (globalVars.APP_DEBUG && typeof constant === 'undefined') {
        throw new Error('La costante ' + name + ' non è definita');
    }

    return constant;
};
